import axios from 'axios'

// state
export const state = {
  isHowToPlayVisible: false,
  isFirstSlideSkipped: false,
}

// getters
export const getters = {
}
// mutations
export const mutations = {
  setHowToPlayModalVisibility(state, { isVisible, ...rest }) {
    state.isHowToPlayVisible = isVisible
    state.isFirstSlideSkipped = rest.isFirstSlideSkipped || false
  },
}
// actions
export const actions = {
  async openHowToPlayModal({ commit }, params) {
    commit('setHowToPlayModalVisibility', {
      isVisible: true,
      ...params,
    })
  },
  async closeHowToPlayModal({ commit }) {
    await axios.post(`profile/confirmHowToPlay`)
    commit('setHowToPlayModalVisibility', { isVisible: false })
  },
}
